/**
 * Pure builders for entity-type React Flow nodes on the canvas. Used by Add Context,
 * quick-add, and drag-drop so dimensions and `data.entity` stay consistent.
 */

import { getEntityMediaDisplayBox } from "@/pages/canvas/utils/imageDimensions";
import type { Entity } from "@cohesive/ui-components";
import type { Node } from "@xyflow/react";
import { v4 as uuidv4 } from "uuid";

export interface EntityNodeSizing {
  getEntityNodeWidth: (entity: Entity) => number;
  getEntityNodeHeight: (entity: Entity) => number;
}

/** Entity node at an explicit flow position (quick-add, explorer drop grid cells). */
export function buildEntityNodeAtFlowPosition(
  entity: Entity,
  position: { x: number; y: number },
  sizing: EntityNodeSizing,
): Node {
  const nodeW = sizing.getEntityNodeWidth(entity);
  const nodeH = sizing.getEntityNodeHeight(entity);
  const persistFittedMediaDims = getEntityMediaDisplayBox(entity) != null;
  return {
    id: uuidv4(),
    type: "entity",
    position,
    ...(persistFittedMediaDims ? { width: nodeW, height: nodeH } : {}),
    data: { entity },
  };
}
